import React, { useState } from "react"
import { motion } from "framer-motion"
import Backdrop from "./Backdrop"
import { AiFillCloseCircle } from "react-icons/ai"
import PhoneInput from "react-phone-input-2"
import Toastify from "toastify-js"

const dropIn = {
  hidden: {
    y: "-100vh",
    opacity: 0,
  },
  visible: {
    y: "0",
    opacity: 1,
    transition: { type: "spring", damping: 25, shiftness: 500, duration: 0.1 },
  },
  exit: {
    y: "100vh",
    opacity: 0,
  },
}

const Modal = ({ handleClose, text, body, responsive }) => {

  const [values, setValues] = useState({
    name: "",
    lastname: "",
    email: "",
    phone: "",
    companyname: "",
    position: "",
    message: "",
  })

  const handleChange = e => {
    setValues({
      ...values,
      [e.target.name]: e.target.value,
    })
  }

  let disabledButton = true

  if (
    values.name &&
    values.lastname &&
    values.email &&
    values.phone &&
    values.companyname
  ) {
    disabledButton = false
  }

  const handleSubmit = e => {
    e.preventDefault()
    var xhr = new XMLHttpRequest()
    var url =
      "https://api.hsforms.com/submissions/v3/integration/submit/6188058/e13ac177-2085-4eb6-952b-e6c5f65ee288"
    var data = {
      fields: [
        {
          name: "email",
          value: values.email,
        },
        {
          name: "firstname",
          value: values.name,
        },
        {
          name: "0-2/name",
          value: values.name,
        },
        {
          name: "lastname",
          value: values.lastname,
        },
        {
          name: "phone",
          value: values.phone,
        },
        {
          name: "companyname",
          value: values.companyname,
        },
        {
          name: "message",
          value: values.message,
        },
      ],
      context: {
        pageUri: "https://daliaempower.com/b2b",
        pageName: "B2B DaliaEmpower",
      },
    }
    var final_data = JSON.stringify(data)

    xhr.open("POST", url)
    // Sets the value of the 'Content-Type' HTTP request headers to 'application/json'
    xhr.setRequestHeader("Content-Type", "application/json")
    xhr.onreadystatechange = function (e) {
      if (xhr.readyState === 4 && xhr.status === 200) {
        Toastify({
          text: "Información enviada correctamente",
          style: {
            background: "black",
            color: "white",
            borderRadius: "5px",
          },
        }).showToast() // Returns a 200 response if the submission is successful.
      } else if (xhr.readyState === 4 && xhr.status === 403) {
        Toastify({
          text: "Hubo un error al enviar la información",
          style: {
            background: "red",
            color: "white",
            borderRadius: "5px",
          },
        }).showToast()
      } else if (xhr.readyState === 4 && xhr.status === 400) {
        Toastify({
          text: "Verifica tus datos",
          style: {
            background: "red",
            color: "white",
            borderRadius: "5px",
          },
        }).showToast()
      }
    }

    // Sends the request
    xhr.send(final_data)
  }


  return (
    <Backdrop onClick={handleClose}>
      <motion.div
        onClick={e => e.stopPropagation()}
        className={`${responsive ? "modal-responsive" : "modal-auto"}`}
        variants={dropIn}
        initial="hidden"
        animate="visible"
        exit="exit"
      >
        <p>{text}</p>
        <AiFillCloseCircle className="close-button" onClick={handleClose} />
        {body ? (
          body
        ) : (
          <form onSubmit={handleSubmit} className="contact-form">
            <div className="image-container">
              <img
                src="https://cdn.daliaempower.com/landing/static/assets/images/newhome/daliaNew.png"
                alt="DaliaEmpower"
              />
            </div>
            <div className="flex">
              <div className="flex-column">
                <label htmlFor="name">Nombre</label>
                <input
                  id="name"
                  name="name"
                  type="text"
                  placeholder="Maria"
                  required
                  onChange={handleChange}
                  value={values.name}
                />
              </div>
              <div className="flex-column" style={{ marginLeft: "50px" }}>
                <label htmlFor="lastname">Apellido</label>
                <input
                  id="lastname"
                  name="lastname"
                  type="text"
                  placeholder="Jose"
                  required
                  onChange={handleChange}
                  value={values.lastname}
                />
              </div>
            </div>
            <label htmlFor="email">Correo electrónico </label>
            <input
              id="email"
              name="email"
              type="email"
              placeholder="email"
              required
              onChange={handleChange}
              value={values.email}
            />
            <label htmlFor="phone">Telefono </label>
            <PhoneInput
              id="phone"
              name="phone"
              country={"mx"}
              value={values.phone}
              rules={{ required: true }}
              onChange={phone =>
                setValues({
                  ...values,
                  phone,
                })
              }
              style={{ marginBottom: "15px" }}
            />
            <label htmlFor="companyname">Nombre de la empresa </label>
            <input
              id="companyname"
              name="companyname"
              type="text"
              placeholder="Empresa"
              required
              onChange={handleChange}
              value={values.companyname}
            />
            <label htmlFor="position">Cargo</label>
            <input
              id="position"
              name="position"
              type="text"
              placeholder="RRHH"
              onChange={handleChange}
              value={values.position}
            />
            <label htmlFor="message">Mensaje</label>
            <input
              id="message"
              name="message"
              type="text"
              placeholder="Escriu tu mensaje"
              onChange={handleChange}
              value={values.message}
            />
            <button className={disabledButton ? "disabled" : "abled"}>
              Enviar
            </button>
          </form>
        )}
      </motion.div>
    </Backdrop>
  )
}

export default Modal